const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container
      ? {
          container,
          addressContainer: container.querySelector(selectors.addressContainer),
          toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
          cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
          deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
          countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
        }
      : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew',
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`,
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  };

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`));
  };

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  };
}
/* document.addEventListener("scroll", function () {
  const header = document.querySelector(".header"); // Sélectionne l'en-tête
  if (window.scrollY > 50) { // Si l'utilisateur défile de plus de 50px
    header.classList.add("header--scrolled"); // Ajoute la classe
  } else {
    header.classList.remove("header--scrolled"); // Supprime la classe
  }
});
document.addEventListener("scroll", function () {
  const header = document.querySelector(".header"); // Assurez-vous que la classe est correcte
  if (window.scrollY > 50) {
    header.classList.add("header--scrolled"); // Ajoute une classe après défilement
  } else {
    header.classList.remove("header--scrolled"); // Supprime la classe si on revient en haut
  }
}); */

































let currentSlide = 0; // Index de la diapositive active
const slides = document.querySelectorAll('.reviews-slider .slider-item');  // Sélectionne toutes les diapositives
const dots = document.querySelectorAll('.slider-dots .dot');  // Sélectionne tous les points de navigation

let startX = 0; // Position du début du swipe
let swipeDistance = 0; // Distance parcourue pendant le swipe
let isSwiping = false; // Indicateur pour savoir si un swipe est en cours

// Fonction pour mettre à jour les points actifs en fonction de la diapositive visible
function updateActivePoint(index) {
  // Enlever la classe active de tous les points
  dots.forEach(dot => {
    dot.classList.remove('active');
  });

  // Ajouter la classe active au point correspondant à la diapositive visible
  dots[index].classList.add('active');
}

// Fonction pour déplacer la diapositive en fonction du swipe
function updateSlidePosition(percentage) {
  // Déplacer les diapositives en fonction du pourcentage du swipe
  document.querySelector('.reviews-slider .slider-container').style.transform = `translateX(-${(currentSlide * 100) - percentage}%)`;
}

// Fonction pour gérer le swipe
document.querySelector('.reviews-slider').addEventListener('touchstart', (e) => {
  startX = e.touches[0].clientX;  // Capture la position du début du swipe
  swipeDistance = 0;  // Réinitialise la distance du swipe
  isSwiping = true;  // Indique qu'un swipe est en cours
});

document.querySelector('.reviews-slider').addEventListener('touchmove', (e) => {
  if (!isSwiping) return;

  const endX = e.touches[0].clientX;  // Capture la position du doigt pendant le mouvement
  swipeDistance = startX - endX;  // Calcul de la distance parcourue pendant le swipe

  // Applique le déplacement de la diapositive en fonction du swipe
  const swipePercentage = (swipeDistance / window.innerWidth) * 100;
  updateSlidePosition(swipePercentage);  // Déplace les diapositives

  // Calculer la diapositive active en fonction du mouvement du doigt
  const swipePercentageIndex = swipeDistance / window.innerWidth; // Pour déterminer la diapositive en pourcentage
  let newSlide = currentSlide - Math.round(swipePercentageIndex); // Détermine la nouvelle diapositive en fonction du swipe

  // Empêcher les dépassements (swipe au-delà du premier ou dernier slide)
  if (newSlide < 0) newSlide = slides.length - 1;
  if (newSlide >= slides.length) newSlide = 0;

  // Mettre à jour le point actif en temps réel pendant le swipe
  updateActivePoint(newSlide);
});

document.querySelector('.reviews-slider').addEventListener('touchend', () => {
  if (!isSwiping) return;

  // À la fin du swipe, on réajuste la diapositive et le point actif
  currentSlide = Math.round(swipeDistance / window.innerWidth) + currentSlide;

  // Empêcher de dépasser les diapositives
  if (currentSlide < 0) currentSlide = slides.length - 1;
  if (currentSlide >= slides.length) currentSlide = 0;

  // Réinitialiser la position du slider
  document.querySelector('.reviews-slider .slider-container').style.transition = 'transform 0.3s ease';
  document.querySelector('.reviews-slider .slider-container').style.transform = `translateX(-${currentSlide * 100}%)`;

  // Mettre à jour le point actif
  updateActivePoint(currentSlide);

  // Réinitialiser la distance du swipe
  swipeDistance = 0;

  // Réinitialiser l'état du swipe
  isSwiping = false;
});

// Initialiser le premier point actif au chargement
updateActivePoint(currentSlide);
























